/* Different app-wide settings */

export const REACT_QUERY_STALE_TIME = 1000 * 60;

export const reactQueryOptions = {
  staleTime: REACT_QUERY_STALE_TIME,
  keepPreviousData: false,
};
